import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../../constants/index";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../../services/serviceCaller";
import Select from "react-select";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";

const EmployeeTaxRegimeAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("Employee Tax Regime"));
  }, []);

  const initialData = {
    financicalyear: "",
    EmployeeID: "",
    CityTypeID: "",
    TaxRegimeID: "",
  };

  const [formData, setFormData] = useState(initialData);
  const [searchTerm, setSearchTerm] = useState("");
  const [taxRegime, setTaxRegime] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [financialYear, setFinancialYear] = useState([]);
  const [cityOpt, setCityOpt] = useState([]);
  const [employeeOpt, setEmployeeOpt] = useState([]);
  const [RegimeTypeOpt, setRegimeTypeOpt] = useState([]);
  const [isEmployeeSelectEnabled, setIsEmployeeSelectEnabled] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchTaxRegime = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/finance/employee-tax-regime`
      );
      if (response.status === 200) {
        const TaxData = response?.data?.data;
        setTaxRegime(TaxData);

        // financialYear opt
        const year = response?.data?.financialyear;
        const yearOpt = year.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setFinancialYear(yearOpt);

        // employee list
        const employee = response?.data?.employee;
        const empList = employee.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setEmployeeOpt(empList);

        // regimetype list
        const regime = response?.data?.regimetype;
        const regimetype = regime.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setRegimeTypeOpt(regimetype);

        // City Type Option
        const city = response?.data?.citytype;
        const CityOpt = city.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setCityOpt(CityOpt);
        setPageLoading(false);
      } else {
        console.error(
          "Failed to fetch Tax Regime. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Tax Regime:", error);
    }
  };
  useEffect(() => {
    fetchTaxRegime();
  }, []);

  const handleFinancialYear = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      financicalyear: selectedOption.value,
    }));
    setIsEmployeeSelectEnabled(true);

    if (selectedOption) {
      setFormErrors((prev) => ({
        ...prev,
        financicalyear: "",
      }));
    }
  };

  const handleEmployee = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      EmployeeID: selectedOption?.value,
    }));

    if (selectedOption) {
      setFormErrors((prev) => ({
        ...prev,
        EmployeeID: "",
      }));
    }
  };

  const handleChange = (field) => (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: selectedOption.value,
    }));
  };

  const fetchRegimeData = async () => {
    const Employee = formData?.EmployeeID;
    const FinanceYear = formData?.financicalyear;
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/finance/check-employee-tax-regime?pid=${Employee}&financicalyear=${FinanceYear}`
      );
      const checkData = response?.data?.data;
      if (checkData === 1) {
        toast.error("Employee Already Exists");
        handleEmployee(null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    // Trigger API call when both form values are selected
    if (formData.financicalyear && formData.EmployeeID) {
      fetchRegimeData();
    }
  }, [formData.financicalyear, formData.EmployeeID]);

  const validationSchema = Yup.object().shape({
    financicalyear: Yup.string()
      .required("Financial Year is required")
      .nullable(),
    EmployeeID: Yup.string().required("Employee is required").nullable(),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Validate the form
      await validationSchema.validate(formData, { abortEarly: false });
      setFormErrors({});

      const method = "post"; // Always use POST
      const apiUrl = `${API_URL}payroll/finance/employee-tax-regime`;

      const response = await PostServiceCaller(apiUrl, formData, method);

      if (response.status === 200) {
        toast.success("Form submitted successfully!");
        setFormData(initialData);
        setTimeout(() => {
          navigate("/employee-tax-regime");
        }, 2000);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false)

      if (error.name === "ValidationError") {
        const errors = {};
        error.inner.forEach((validationError) => {
          errors[validationError.path] = validationError.message;
        });
        setFormErrors(errors);
      } else {
        console.error("Error submitting form:", error);
      }
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row p-2">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-3">
                    <div class="mb-3">
                      <label for="Code" class="form-label">
                        Financial Year<span className="required">*</span>
                      </label>
                      <Select
                        options={financialYear}
                        value={financialYear.find(
                          (option) => option.label === formData.financicalyear
                        )}
                        onChange={handleFinancialYear}
                        className={
                          formErrors.financicalyear ? "error-input" : ""
                        }
                      />
                      {formErrors.financicalyear && (
                        <div className="text-danger">
                          {formErrors.financicalyear}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div class="mb-3">
                      <label for="Code" class="form-label">
                        Employee<span className="required">*</span>
                      </label>
                      <Select
                        options={employeeOpt}
                        value={
                          formData.EmployeeID
                            ? employeeOpt.find(
                              (option) => option.value === formData.EmployeeID
                            )
                            : null
                        }
                        onChange={handleEmployee}
                        isDisabled={!isEmployeeSelectEnabled}
                        className={formErrors.EmployeeID ? "error-input" : ""}
                      />
                      {formErrors.EmployeeID && (
                        <div className="text-danger">
                          {formErrors.EmployeeID}
                        </div>
                      )}
                    </div>
                  </div>
                  {financialYear
                    .slice(-3)
                    .some(
                      (option) => option.value === formData.financicalyear
                    ) && (
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label htmlFor="Code" className="form-label">
                            Tax Regime Type<span className="required">*</span>
                          </label>
                          <Select
                            options={RegimeTypeOpt}
                            value={RegimeTypeOpt.find(
                              (option) => option.value === formData.TaxRegimeID
                            )}
                            onChange={handleChange("TaxRegimeID")}
                          />
                        </div>
                      </div>
                    )}

                  <div className="col-md-3">
                    <div class="mb-3">
                      <label for="Code" class="form-label">
                        City Type
                      </label>
                      <Select
                        options={cityOpt}
                        onChange={handleChange("CityTypeID")}
                        value={cityOpt.find(
                          (option) => option.value === formData.CityTypeID
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="text-end mt-2">
                  <button
                    className="cancel-btn me-2"
                    onClick={() => navigate("/employee-tax-regime")}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="custom-btn">
                    {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default EmployeeTaxRegimeAdd;
